'use client';

import { EmptyState } from '@/components/EmptyState';
import { PastTournamentCard } from '@/components/pickems/tournaments/PastTournamentCard';
import { type Tab, Tabs } from '@/components/Tabs';
import { Game } from '@/constants/game.const';
import type { Tournament } from '@/types/tournament';
import { getTournamentPath } from '@/utils/paths';

export function PastTournaments({
  tournaments,
}: {
  tournaments: Tournament[];
}) {
  const tabs: Tab[] = [
    { label: 'All Tournaments', path: getTournamentPath() },
    { label: 'CS 2', path: getTournamentPath({ game: Game.CS2 }) },
    { label: 'Dota 2', path: getTournamentPath({ game: Game.DOTA }) },
  ];
  return (
    <div className="space-y-6">
      <Tabs tabs={tabs} />
      <h1 className="font-bold text-2xl">Past Tournaments</h1>
      {tournaments.length > 0 ? (
        <PastTournamentsList tournaments={tournaments} />
      ) : (
        <div className="rounded-lg bg-card-bg px-3 py-5">
          <EmptyState
            description="We couldn't find any past tournaments."
            title="No past tournaments found"
          />
        </div>
      )}
    </div>
  );
}

function PastTournamentsList({ tournaments }: { tournaments: Tournament[] }) {
  return (
    <>
      <div className="grid gap-6 gap-x-3 md:grid-cols-4">
        {tournaments.map((tournament) => (
          <PastTournamentCard key={tournament.id} tournament={tournament} />
        ))}
      </div>
      {/* Mocked data for now, pagination is not needed */}
      {/* <Pagination
        currentPage={1}
        // biome-ignore lint/suspicious/noEmptyBlockStatements: mocking for now
        onChange={() => {}}
        perPageItems={12}
        totalCount={80}
        totalPages={7}
      /> */}
    </>
  );
}
